import React, { FC } from "react";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const InfoCircle: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faCircleInfo} {...props} />
);
